import { Globe } from "lucide-react";
import { useI18n, type LanguageCode } from "@/lib/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSelector({ compact = false }: { compact?: boolean }) {
  const { language, setLanguage, availableLanguages, t } = useI18n();
  const current = availableLanguages.find((l) => l.code === language) ?? availableLanguages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          aria-label={t("nav.language")}
          className={`inline-flex items-center gap-1.5 rounded-full bg-secondary/70 text-brown-dark transition hover:bg-brand-soft ${
            compact ? "h-9 w-9 justify-center" : "h-9 px-3 text-xs font-semibold"
          }`}
        >
          <Globe className="h-4 w-4" />
          {!compact && <span>{current?.label ?? "English"}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-40">
        {availableLanguages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onSelect={() => setLanguage(l.code as LanguageCode)}
            className={`text-sm ${l.code === language ? "font-semibold text-brown-dark" : ""}`}
          >
            <span className="flex-1">{l.label}</span>
            <span className="text-[11px] text-muted-foreground">{l.english}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
